
import React from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Clock } from "lucide-react";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
} from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { UseFormReturn } from "react-hook-form";
import { SermonTypeSelect } from "./SermonTypeSelect";

interface AdditionalInfoTabProps {
  form: UseFormReturn<any>;
}

export function AdditionalInfoTab({ form }: AdditionalInfoTabProps) {
  return (
    <>
      <SermonTypeSelect form={form} />

      <FormField
        control={form.control}
        name="theme"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Main Theme/Topic</FormLabel>
            <FormControl>
              <Input
                placeholder="e.g. Faith, Grace, Forgiveness"
                {...field}
                className="focus:ring-2 focus:ring-offset-1 focus:ring-primary-500"
              />
            </FormControl>
            <FormDescription>
              The primary theme or topic of your sermon
            </FormDescription>
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="target_duration"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center">
              <Clock className="w-4 h-4 mr-2" />
              Target Duration (minutes)
            </FormLabel>
            <Select
              value={field.value}
              onValueChange={field.onChange}
              defaultValue="30"
            >
              <FormControl>
                <SelectTrigger className="focus:ring-2 focus:ring-offset-1 focus:ring-primary-500">
                  <SelectValue placeholder="Select duration" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="15">15 minutes</SelectItem>
                <SelectItem value="20">20 minutes</SelectItem>
                <SelectItem value="30">30 minutes</SelectItem>
                <SelectItem value="45">45 minutes</SelectItem>
                <SelectItem value="60">60 minutes</SelectItem>
              </SelectContent>
            </Select>
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="key_points"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Key Points</FormLabel>
            <FormControl>
              <Textarea
                placeholder="List main points to cover"
                {...field}
                rows={3}
                className="focus:ring-2 focus:ring-offset-1 focus:ring-primary-500"
              />
            </FormControl>
            <FormDescription>
              Outline the main points to cover in your sermon
            </FormDescription>
          </FormItem>
        )}
      />
    </>
  );
}
